import HistoryIcon from "@mui/icons-material/History";
import { Box, Card, CardContent, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import AssistantCreditsHistoryDialog from "./AssistantCreditsHistoryDialog";

function formatCredits(value) {
    if (value === null || value === undefined || Number.isNaN(Number(value))) {
        return "—";
    }
    return Number(value).toLocaleString();
}

/**
 * Shows puzzle AI assistant credit balances for an admin-viewed user.
 * Fields match the cloud user payload from GET /home/user (assistantFreeBalance, etc.).
 */
export default function AssistantCreditsAdmin({ userDetails, userId: subjectUserId = null }) {
    const [historyOpen, setHistoryOpen] = useState(false);

    if (!userDetails) {
        return null;
    }

    const free = userDetails.assistantFreeBalance;
    const paid = userDetails.assistantPaidBalance;
    const total = userDetails.assistantCreditsTotal;

    return (
        <Card sx={{ mt: 3 }}>
            <CardContent>
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, mb: 1 }}>
                    <Typography variant="h5" component="h2" sx={{ m: 0 }}>
                        Coins
                    </Typography>
                    <Tooltip title="Open credits history (ledger)">
                        <IconButton
                            size="small"
                            aria-label="Open assistant credits history"
                            onClick={() => setHistoryOpen(true)}
                        >
                            <HistoryIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Credit balances for the puzzle AI assistant (free tier, purchased, and total).
                </Typography>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Typography variant="body2" color="text.secondary">
                            Free balance
                        </Typography>
                        <Typography variant="h6" component="p" sx={{ mt: 0.5, fontWeight: 700 }}>
                            {formatCredits(free)}
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Typography variant="body2" color="text.secondary">
                            Paid balance
                        </Typography>
                        <Typography variant="h6" component="p" sx={{ mt: 0.5, fontWeight: 700 }}>
                            {formatCredits(paid)}
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <Typography variant="body2" color="text.secondary">
                            Total
                        </Typography>
                        <Typography variant="h6" component="p" sx={{ mt: 0.5, fontWeight: 700 }}>
                            {formatCredits(total)}
                        </Typography>
                    </Grid>
                </Grid>
                <AssistantCreditsHistoryDialog
                    open={historyOpen}
                    onClose={() => setHistoryOpen(false)}
                    subjectUserId={subjectUserId}
                />
            </CardContent>
        </Card>
    );
}
